import { getLoggedInUserRole } from "./modules/common/user/UserService";
import { UnauthorizedPage } from "./pages/app/UnauthorizedPage";

type RoleProtectedRouteProps = {
  allowedRoles: string[];
  children: any;
};

export const RoleProtectedRoute = ({ allowedRoles, children }: RoleProtectedRouteProps) => {
  const role = getLoggedInUserRole();

  if (allowedRoles.includes(role)) {
    return children;
  }

  return <UnauthorizedPage />;
};
